// extracted by mini-css-extract-plugin
module.exports = {"TitleDescription":"TitleDescription_TitleDescription__halMj","title":"TitleDescription_title__Y4-Fy","description":"TitleDescription_description__QA74I"};